//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
    name: 'TopCurrencyText',
    data() {
        return {
        };
    },
    mounted() {
    },
    computed: {
        ...mapState([ 'topCurrency' ]),
    },
    methods: {
    },

};
